
export default (http) => ({
    pull(url, queryParams) {
        return http.get(`${url}`, { params: queryParams });
    },
    push(url, payload) {
        return http.post(`${url}`, payload);
    },
    pingForNewReadingAnswersFromIA() {
        return http.get('/readings/ping-for-new-reading-answers-from-ia');
    }
});
